import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  addLimit: 'يمكنك اضافة حتي <tag>{{number}}</tag> بطاقات دفع خاصة بك',
  addCard: 'اضف',
  noCardsAdded: 'ليس لديك بطاقات ائتمان محفوظة ',
  addCardsForEasyPay: 'اضف بطاقات لسهولة الدفع',
  expiresIn: 'تنتهي في',
  cardNumber: 'رقم البطاقة',
  cardNumberLengthError: 'رقم البطاقة لا يمكن ان يقل عن 16 او 15 رقم',
  cardNumberPlaceholder: 'رقم البطاقة',
  holderName: 'اسم حامل البطاقة',
  holderNamePlaceholder: 'اكتب اسم حامل البطاقة',
  expiryDate: 'تاريخ الانتهاء',
  invalidExpiryDate: 'تاريخ الانتهاء غير صحيح',
  deleteCard: 'حذف البطاقة',
  cancelConfirmation: 'هل انت متأكد انك تريد حذف هذه البطاقة؟',
  invalidCardNumber: 'رقم بطاقة غير صحيح',
  invalidHolderName: 'اسم صاحب البطاقة غير صحيح',
  cvv: 'رقم CVV ',
  cvvPlaceholder: 'CVV',
  invalidCvv: 'CVV غير صحيح',
});
